import '../../main.scss';

import BaseComponent from '@utils/base.js';
import tag from '@utils/utilTags.js';
import Dashboard from '@components/dashboard/dashboard.js';
import Field from '@components/field/field.js';
import Modal from '@components/modal/modal.js';

import * as styles from './page.module.scss';

/**
 * @extends {BaseComponent<HTMLElement>}
 */
export default class Page extends BaseComponent {
  constructor() {
    super({ elementTag: 'main', classes: [styles.main] });

    const gameField = tag.div({ classes: [styles.gameField] }, new Field());

    this.appendChildren(new Modal(), new Dashboard(), gameField);
  }

  /**
   * Appends the page component to document's body.
   * @returns {void}
   */
  mount() {
    document.body.append(this.getElement());
  }
}
